// extracted by mini-css-extract-plugin
export default {"carts":"Home_carts__M6AOq","Box":"Home_Box__aNEgg","head":"Home_head__4IM4G","story":"Home_story__URNPh"};